// src/portfolio/Resume.jsx — printable single-page résumé
import React from 'react';
import { IDENTITY } from './data';

function SectionHead({ children }) {
  return (
    <div style={{ fontSize: 10, letterSpacing: '.18em', textTransform: 'uppercase', color: '#888', fontWeight: 600 }}>
      {children}
    </div>
  );
}

function Row({ when, what, where, children }) {
  return (
    <div style={{ marginTop: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
        <div style={{ fontSize: 12, fontWeight: 600 }}>
          {what} <span style={{ color: '#555', fontWeight: 400 }}>· {where}</span>
        </div>
        <div style={{ fontSize: 10, color: '#777' }}>{when}</div>
      </div>
      <p style={{ margin: '2px 0 0', color: '#333' }}>{children}</p>
    </div>
  );
}

export default function Resume() {
  const id = IDENTITY;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 40px' }}>
      <div style={{
        width: '100%', maxWidth: 640, aspectRatio: '8.5 / 11',
        background: '#fdfcf8', color: '#1a1a1a', borderRadius: 4,
        boxShadow: '0 24px 60px rgba(0,0,0,0.5), 0 2px 6px rgba(0,0,0,0.4)',
        padding: '54px 56px', fontFamily: "'Inter', sans-serif", fontSize: 11, lineHeight: 1.5,
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', borderBottom: '1.5px solid #1a1a1a', paddingBottom: 10 }}>
          <div>
            <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.01em' }}>{id.name}</div>
            <div style={{ fontSize: 11, color: '#555', marginTop: 2 }}>{id.role} · {id.location}</div>
          </div>
          <div style={{ fontSize: 10, color: '#555', textAlign: 'right' }}>
            <div>{id.email}</div>
            <div>github.com/{id.github}</div>
            <div>linkedin.com/in/{id.linkedin}</div>
          </div>
        </div>

        <div style={{ marginTop: 18 }}>
          <SectionHead>Summary</SectionHead>
          <p style={{ margin: '4px 0 0' }}>
            Databricks-certified Data Engineer with experience building and governing enterprise data platforms in
            regulated banking environments. Skilled in ETL/ELT across the medallion architecture using Spark,
            Delta Lake, and Unity Catalog on Azure. Most recently owned access control governance and led
            regulatory data migration at a major Canadian bank.
          </p>
        </div>

        <div style={{ marginTop: 14 }}>
          <SectionHead>Experience</SectionHead>
          <Row when="Dec 2025 — Mar 2026" what="Data Engineer" where="CIBC · AML Data Platform">
            Owned the view-based access control (VBAC) framework across 10+ data-product schemas. Led a regulatory
            transaction reporting migration through SIT, UAT, pre-prod, and production on Databricks / Azure.
          </Row>
          <Row when="Jul 2025 — Oct 2025" what="Data Engineer" where="Citco · Data Migration">
            Led the JDBC ingestion module inside Citco's Centralized Data Platform — MySQL, Postgres, SQL Server,
            and Oracle into Databricks. Designed the active-semi-active DR posture for DLT / managed tables.
          </Row>
          <Row when="Apr 2024 — present" what="Data Engineer" where="Jarvis Consulting Group">
            Internal platform: medallion ELT in Unity Catalog, YAML-driven Salesforce / AWS / Snowflake ingestion,
            data-masking framework for PII / PCI, RBAC vs. dynamic masking benchmarking.
          </Row>
        </div>

        <div style={{ marginTop: 14 }}>
          <SectionHead>Certifications</SectionHead>
          <p style={{ margin: '4px 0 0' }}>
            <strong>Databricks Data Engineer Professional</strong> · <strong>Databricks Data Engineer Associate</strong> ·{' '}
            IBM Python for Data Science · Intro to Cloud Computing.
          </p>
        </div>

        <div style={{ marginTop: 14 }}>
          <SectionHead>Stack</SectionHead>
          <p style={{ margin: '4px 0 0' }}>
            Spark · Delta Lake · Databricks · Unity Catalog · Kafka · Azure (ADLS Gen2, Data Factory, Synapse) ·
            AWS · GCP · Python · SQL · Scala · Java · Jenkins · Docker · Git · Bitbucket.
          </p>
        </div>

        <div style={{ marginTop: 14 }}>
          <SectionHead>Education</SectionHead>
          <p style={{ margin: '4px 0 0' }}>
            <strong>Seneca Polytechnic College</strong> — Diploma in Computer Programming · 2019–2023 · honours, GPA 3.7/4.0.
            <br />
            <strong>BrainStation</strong> — Certificate in Software Engineering · 2023 · distinction, 92% cumulative.
          </p>
        </div>

        <div style={{ position: 'absolute', bottom: 14, right: 18, fontSize: 9, color: '#aaa' }}>1 / 1</div>
      </div>
    </div>
  );
}
